module.exports = __webpack_public_path__ + "img/toy-horse.80cf29fd.svg";